var _BaseServiceV2 = require('./core/_BaseServiceV2');

module.exports = _BaseServiceV2.create('recommendation', {
	studentLibraryCollaborativeRead: {
		cache: 'studentLibraryCollaborativeRead',
		keyFunction: JSON.stringify.bind(JSON)
	}
});
